import React from "react";
import PropTypes from "prop-types";
import { graphql } from "gatsby";
import LinkWrapper from "@/components/linkWrapper";
import MediaWrapper from "@/components/mediaWrapper";
import MarkdownWrapper from "@/components/markdownWrapper";

export const query = graphql`
  fragment TestimonialSideBySideOnBrandData on StrapiComponentTestimonialSideBySideOnBrand {
    testimonials {
      name
      jobTitle
      text
      image {
        ...StrapiMediaSubquery
      }
      companyLogo {
        ...StrapiSharedLink
      }
    }
  }
`;

function SideBySideOnBrand({ data }) {
  if (!data) {
    return <template />;
  }
  let firstTestimonial;
  let testimonials;
  if (data) {
    testimonials = [...data.testimonials];
    if (testimonials.length) {
      firstTestimonial = testimonials.shift();
    }
  }
  return (
    <section className="bg-background-primary-dark">
      {data.testimonials && (
        <div className="mx-auto max-w-7xl md:grid md:grid-cols-2 md:px-6 lg:px-8">
          <div className="px-4 py-12 sm:px-6 md:flex md:flex-col md:border-r md:border-border-primary-dark md:py-16 md:pl-0 md:pr-10 lg:pr-16">
            <div className="md:flex-shrink-0">
              {(firstTestimonial?.companyLogo?.overwriteIcon ||
                firstTestimonial?.companyLogo?.link?.icon) && (
                <LinkWrapper
                  to={firstTestimonial?.companyLogo?.link?.url}
                  className="inline-flex"
                >
                  <MediaWrapper
                    media={
                      firstTestimonial.companyLogo.overwriteIcon ||
                      firstTestimonial.companyLogo.link.icon
                    }
                    divClassName="h-12"
                    objectFit="contain"
                  />
                </LinkWrapper>
              )}
            </div>
            <blockquote className="mt-6 md:flex md:flex-grow md:flex-col">
              <div className="relative text-lg font-medium text-text-white md:flex-grow">
                <svg
                  className="absolute left-0 top-0 h-8 w-8 -translate-x-3 -translate-y-2 transform text-text-primary"
                  fill="currentColor"
                  viewBox="0 0 32 32"
                  aria-hidden="true"
                >
                  <path d="M9.352 4C4.456 7.456 1 13.12 1 19.36c0 5.088 3.072 8.064 6.624 8.064 3.36 0 5.856-2.688 5.856-5.856 0-3.168-2.208-5.472-5.088-5.472-.576 0-1.344.096-1.536.192.48-3.264 3.552-7.104 6.624-9.024L9.352 4zm16.512 0c-4.8 3.456-8.256 9.12-8.256 15.36 0 5.088 3.072 8.064 6.624 8.064 3.264 0 5.856-2.688 5.856-5.856 0-3.168-2.304-5.472-5.184-5.472-.576 0-1.248.096-1.44.192.48-3.264 3.456-7.104 6.528-9.024L25.864 4z" />
                </svg>
                {firstTestimonial.text && (
                  <MarkdownWrapper
                    text={firstTestimonial.text}
                    markdownClassName="relative"
                    replaceParagraph={false}
                  />
                )}
              </div>
              <footer className="mt-8">
                <div className="flex items-start">
                  <div className="inline-flex flex-shrink-0 rounded-full border-2 border-border-white">
                    {firstTestimonial.image && (
                      <MediaWrapper
                        media={firstTestimonial.image}
                        divClassName="h-12 w-12"
                        className="rounded-full"
                      />
                    )}
                  </div>
                  <div className="ml-4">
                    {firstTestimonial.name && (
                      <div className="text-base font-medium text-text-white">
                        {firstTestimonial.name}
                      </div>
                    )}
                    {firstTestimonial.jobTitle && (
                      <div className="text-base font-medium text-text-primary-light">
                        <MarkdownWrapper text={firstTestimonial.jobTitle} />
                      </div>
                    )}
                  </div>
                </div>
              </footer>
            </blockquote>
          </div>
          {Boolean(testimonials?.length) &&
            testimonials.map((testimonial, index) => (
              <div
                key={index}
                className="border-t-2 border-border-primary-dark px-4 py-12 sm:px-6 md:border-l md:border-t-0 md:py-16 md:pl-10 md:pr-0 lg:pl-16"
              >
                <div className="md:flex-shrink-0">
                  {(testimonial.companyLogo?.overwriteIcon ||
                    testimonial.companyLogo?.link?.icon) && (
                    <LinkWrapper
                      to={testimonial?.companyLogo?.link?.url}
                      className="inline-flex"
                    >
                      <MediaWrapper
                        media={
                          testimonial.companyLogo.overwriteIcon ||
                          testimonial.companyLogo.link.icon
                        }
                        divClassName="h-12"
                        objectFit="contain"
                      />
                    </LinkWrapper>
                  )}
                </div>
                <blockquote className="mt-6 md:flex md:flex-grow md:flex-col">
                  <div className="relative text-lg font-medium text-text-white md:flex-grow">
                    <svg
                      className="absolute left-0 top-0 h-8 w-8 -translate-x-3 -translate-y-2 transform text-text-primary"
                      fill="currentColor"
                      viewBox="0 0 32 32"
                    >
                      <path d="M9.352 4C4.456 7.456 1 13.12 1 19.36c0 5.088 3.072 8.064 6.624 8.064 3.36 0 5.856-2.688 5.856-5.856 0-3.168-2.208-5.472-5.088-5.472-.576 0-1.344.096-1.536.192.48-3.264 3.552-7.104 6.624-9.024L9.352 4zm16.512 0c-4.8 3.456-8.256 9.12-8.256 15.36 0 5.088 3.072 8.064 6.624 8.064 3.264 0 5.856-2.688 5.856-5.856 0-3.168-2.304-5.472-5.184-5.472-.576 0-1.248.096-1.44.192.48-3.264 3.456-7.104 6.528-9.024L25.864 4z" />
                    </svg>
                    {testimonial.text && (
                      <MarkdownWrapper
                        text={testimonial.text}
                        markdownClassName="relative"
                        replaceParagraph={false}
                      />
                    )}
                  </div>
                  <footer className="mt-8">
                    <div className="flex items-start">
                      <div className="inline-flex flex-shrink-0 rounded-full border-2 border-border-white">
                        {testimonial.image && (
                          <MediaWrapper
                            media={testimonial.image}
                            divClassName="h-12 w-12"
                            className="rounded-full"
                          />
                        )}
                      </div>
                      <div className="ml-4">
                        {testimonial.name && (
                          <div className="text-base font-medium text-text-white">
                            {testimonial.name}
                          </div>
                        )}
                        {testimonial.jobTitle && (
                          <div className="text-base font-medium text-text-primary-light">
                            <MarkdownWrapper text={testimonial.jobTitle} />
                          </div>
                        )}
                      </div>
                    </div>
                  </footer>
                </blockquote>
              </div>
            ))}
        </div>
      )}
    </section>
  );
}

SideBySideOnBrand.propTypes = {
  data: PropTypes.object,
};

export default SideBySideOnBrand;
